export default "__VITE_ASSET__NHdXkeqT__"